import {mapGetters} from "vuex";
import { getsafe } from '@/libs/util.js'

export default {
    computed: {
        ...mapGetters('async', [
            'employment_types_item_id_hash',
            'employment_forms_item_id_hash'
        ]),
    },
    methods: {
        getEmployeeType(item) {
            //  const hash = this.employment_types_item_id_hash || {}
             const name = getsafe(this.employment_types_item_id_hash, `${item.employment_type_id}.item_text`, '')
             const type = getsafe(this.employment_forms_item_id_hash, `${item.employment_form_id}.item_text`, '') 
          
             return `${type}-${name}`
         },
    },
    created() {
        this.employment_forms_item_id_hash
        this.employment_types_item_id_hash
    }
}